import StyledForm from '../forms/shared/StyledForm';
import FormNumberInput from '../molecules/form-elements/FormNumberInput';
import { useModal } from '../../hooks/useDialog';
import useLocalization from '../../hooks/useLocalization';
import { UserBalance } from '../../@types';
import { useUpdateCredits } from '../../hooks/useUpdateCredits';

const BalanceAdjustmentForm = ({
  userBalanceData,
  handleUpdate,
}: {
  userBalanceData: UserBalance;
  handleUpdate: () => void;
}) => {
  const { t } = useLocalization();
  const { closeModal } = useModal();
  const { onSubmit, isSubmitting, control, handleSubmit } = useUpdateCredits(userBalanceData, handleUpdate);

  const formTitle = `${t('transferBalance')} ${userBalanceData.currency}`;

  return (
    <StyledForm
      title={formTitle}
      submitTitle={t('save')}
      onSubmit={handleSubmit(onSubmit)}
      onClose={closeModal}
      isSubmitting={isSubmitting}
    >
      <FormNumberInput
        name='amount'
        label={t('amount')}
        control={control}
        fullWidth
        disabled={isSubmitting}
        autoFocus
        allowNegative
        slotProps={{ htmlInput: { inputMode: 'text' } }}
      />
    </StyledForm>
  );
};
export default BalanceAdjustmentForm;
